import React from 'react';
import './style.css';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {toJS} from 'mobx';
import classnames from 'classnames';
import {useMediaQuery} from 'react-responsive';
import SingleTrip from 'affiliates/Widget/FerrySearchMask/SingleTrip';
import MultiTrip from 'affiliates/Widget/FerrySearchMask/MultiTrip';
import TypeTripRadios from 'ferries/Home/components/FerrySearchMask/TypeTripRadios';
import {
  ROUND_TRIP_TYPE,
  MULTI_TRIP_TYPE
} from 'ferries/Home/components/FerrySearchMask/helperStore';
import {MOBILE_WIDTH} from 'helpers/stableValues';

const FerrySearchMask = ({store}) => {
  const isMobile = useMediaQuery({query: `(max-width: ${MOBILE_WIDTH}px)`});

  const {loading, triedToSubmit, outline, darkMode, brandLogo, typeTrip, trips, noOfTrips, minTrips, maxTrips,
    popular, joinProgram, btncolor, errors, addTrip, removeTrip, setTypeTrip, setPort, fetchSuggestions,
    clearSuggestions, onSuggestionSelected, portString, portStringNo3Ltr, swapPorts, setDate, setDates,
    setPortByThreeLetterCode, submitForm, translations} = store;
  const isMultiTrip = typeTrip === MULTI_TRIP_TYPE;
  const isRoundTrip = typeTrip === ROUND_TRIP_TYPE;

  const searchMaskTabWrapperClass = classnames(
    'searchMask-tab-wrapper home m-0',
    {outline, 'dark-mode': darkMode}
  );

  return (
    <div className={searchMaskTabWrapperClass}>
      <div className="searchMask-tabs">
        <div className="searchMask-wrapper p-2 bg-white">
          <div className="mb-2">
            <TypeTripRadios
              isMobile={isMobile}
              isAffiliate
              typeTrip={typeTrip}
              color={btncolor}
              setTypeTrip={setTypeTrip}
              translations={translations}
            />
          </div>
          {
            isMultiTrip ?
              <MultiTrip
                isMobile={isMobile}
                loading={loading}
                brandLogo={brandLogo}
                triedToSubmit={triedToSubmit}
                trips={trips}
                noOfTrips={noOfTrips}
                minTrips={minTrips}
                maxTrips={maxTrips}
                popular={popular}
                joinProgram={joinProgram}
                btncolor={btncolor}
                errors={toJS(errors)}
                addTrip={addTrip}
                removeTrip={removeTrip}
                setPort={setPort}
                fetchSuggestions={fetchSuggestions}
                clearSuggestions={clearSuggestions}
                onSuggestionSelected={onSuggestionSelected}
                portString={portString}
                portStringNo3Ltr={portStringNo3Ltr}
                swapPorts={swapPorts}
                setTypeTrip={setTypeTrip}
                setDate={setDate}
                setDates={setDates}
                setPortByThreeLetterCode={setPortByThreeLetterCode}
                submitForm={submitForm}
                translations={translations}
              /> :
              <SingleTrip
                isMobile={isMobile}
                loading={loading}
                brandLogo={brandLogo}
                isRoundTrip={isRoundTrip}
                triedToSubmit={triedToSubmit}
                trips={trips}
                popular={popular}
                joinProgram={joinProgram}
                btncolor={btncolor}
                errors={toJS(errors)}
                setPort={setPort}
                fetchSuggestions={fetchSuggestions}
                clearSuggestions={clearSuggestions}
                onSuggestionSelected={onSuggestionSelected}
                portString={portString}
                portStringNo3Ltr={portStringNo3Ltr}
                swapPorts={swapPorts}
                setTypeTrip={setTypeTrip}
                setDate={setDate}
                setDates={setDates}
                setPortByThreeLetterCode={setPortByThreeLetterCode}
                submitForm={submitForm}
                translations={translations}
              />
          }
        </div>
      </div>
    </div>
  );
};

FerrySearchMask.propTypes = {
  store: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    triedToSubmit: PropTypes.bool.isRequired,
    outline: PropTypes.bool.isRequired,
    darkMode: PropTypes.bool.isRequired,
    brandLogo: PropTypes.string.isRequired,
    typeTrip: PropTypes.number.isRequired,
    trips: PropTypes.object.isRequired,
    noOfTrips: PropTypes.number.isRequired,
    minTrips: PropTypes.number.isRequired,
    maxTrips: PropTypes.number.isRequired,
    popular: PropTypes.bool.isRequired,
    joinProgram: PropTypes.bool.isRequired,
    btncolor: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
    addTrip: PropTypes.func.isRequired,
    removeTrip: PropTypes.func.isRequired,
    fillWithQuery: PropTypes.func.isRequired,
    setPort: PropTypes.func.isRequired,
    fetchSuggestions: PropTypes.func.isRequired,
    clearSuggestions: PropTypes.func.isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    portString: PropTypes.func.isRequired,
    portStringNo3Ltr: PropTypes.func.isRequired,
    swapPorts:PropTypes.func.isRequired,
    setTypeTrip: PropTypes.func.isRequired,
    setDate: PropTypes.func.isRequired,
    setDates: PropTypes.func.isRequired,
    setPortByThreeLetterCode: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    translations: PropTypes.object.isRequired
  })
};

export default observer(FerrySearchMask);
